/* ============================================================
   UGOITA PLUS フロントページ刷新（2026-09）共有スクリプト
   - HEROカルーセル（JSON駆動・自動送り・プログレスバー・サムネ切替）
   - レーン送りボタン（PC・溢れ時のみ）
   - 講師マーキー（シームレスループ用にクローン複製）
   - SPボトムシート（タブバー連動）
   多重初期化ガードあり。セクション単位で重複読込されても1度だけ動作。
   ============================================================ */
/* build: 2026-07-13a (header search/cart をテーマUIへ委譲) */
(function () {
  if (window.__ugoitaFrontInit) return;
  window.__ugoitaFrontInit = true;

  function init() {
    initHero();
    initLaneNav();
    watchUgcLanes();
    initMarquee();
    initSheets();
    initHeaderActions();
    initMegaEscape();
  }

  /* ===== ヘッダー：検索モーダル／カートドロワーをテーマ本体UIに委譲 =====
     別ページ遷移させず、現行トップと同じくページ内で開く。
     テーマのトリガー(.search-modal-trigger / #cart-icon-bubble)が無ければ href 遷移にフォールバック。 */
  function initHeaderActions() {
    document.querySelectorAll('[data-uf-search]').forEach(function (btn) {
      if (btn.__ufBound) return; btn.__ufBound = 1;
      btn.addEventListener('click', function (e) {
        var trigger = document.querySelector('.search-modal-trigger');
        if (!trigger) return;               /* 委譲先が無ければ href の /search へ普通に遷移 */
        e.preventDefault();
        /* SPメニューシートが開いたままだと検索モーダルが背面に出て「押しても何も起きない」
           ように見える（2026-09-01・SPシートに検索を足したときに必要になった）。先に閉じる。 */
        document.querySelectorAll('.uf-sheet.open').forEach(function (s) { s.classList.remove('open'); });
        var tb = document.querySelector('.uf-tabbar');
        if (tb) tb.querySelectorAll('[data-tab]').forEach(function (b) {
          b.classList.toggle('active', b.getAttribute('data-tab') === 'home');
        });
        trigger.click();
      });
    });
    document.querySelectorAll('[data-uf-cart]').forEach(function (btn) {
      if (btn.__ufBound) return; btn.__ufBound = 1;
      btn.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        var icon = document.getElementById('cart-icon-bubble');
        if (drawer && icon) { e.preventDefault(); icon.click(); }
      });
    });
  }

  /* ===== HERO ===== */
  function initHero() {
    var hero = document.querySelector('[data-uf-hero]');
    if (!hero) return;
    // データ要素はセクション直下（[data-uf-hero]の外・兄弟）に出力されるため document から取得
    var dataEl = hero.querySelector('[data-uf-hero-data]') ||
      (hero.closest('.ugoita-front') || document).querySelector('[data-uf-hero-data]') ||
      document.querySelector('[data-uf-hero-data]');
    if (!dataEl) return;
    var slots = [];
    try { slots = JSON.parse(dataEl.textContent || '[]'); } catch (e) { slots = []; }
    if (!slots.length) return;

    var rotate = parseInt(hero.getAttribute('data-rotate-ms'), 10) || 4000;
    document.documentElement.style.setProperty('--rot-ms', rotate + 'ms');

    var media = hero.querySelector('.uf-hero-media');
    var badges = hero.querySelector('.uf-hero-badges');
    var kicker = hero.querySelector('.uf-hero-kicker');
    var title = hero.querySelector('.uf-hero-title');
    var sub = hero.querySelector('.uf-hero-sub');
    var ctaMain = hero.querySelector('.uf-hero-cta-main');
    var ctaSub = hero.querySelector('.uf-hero-cta-sub');
    var prog = hero.querySelector('.uf-hero-progress');
    var rail = hero.querySelector('.uf-hero-rail');
    var idx = 0, timer = null;

    // プログレスバー・サムネ生成
    slots.forEach(function (s, i) {
      var seg = document.createElement('span');
      seg.className = 'uf-hp-seg';
      seg.innerHTML = '<i></i>';
      seg.addEventListener('click', function () { show(i); restart(); });
      prog.appendChild(seg);

      var th = document.createElement('div');
      th.className = 'uf-hero-thumb';
      th.innerHTML =
        '<div class="ht-img"><img src="' + esc(s.thumb) + '" alt="" loading="lazy"></div>' +
        (s.thumbBadge ? '<span class="ht-badge">' + esc(s.thumbBadge) + '</span>' : '') +
        '<div class="ht-label">' + esc(s.thumbLabel || '') + '</div>';
      th.addEventListener('click', function () { show(i); restart(); });
      rail.appendChild(th);
    });

    function show(i) {
      idx = i;
      var s = slots[i];
      if (s.video) {
        media.innerHTML = '<video autoplay muted loop playsinline ' +
          (s.image ? 'poster="' + esc(s.image) + '"' : '') + '><source src="' + esc(s.video) + '" type="video/mp4"></video>';
      } else {
        media.innerHTML = '<img src="' + esc(s.image) + '" alt="">';
      }
      if (kicker) kicker.textContent = s.kicker || '';
      if (title) title.innerHTML = s.title || '';
      if (sub) sub.textContent = s.sub || '';
      if (ctaMain) { ctaMain.textContent = s.ctaMain || ''; if (s.ctaMainUrl) ctaMain.href = s.ctaMainUrl; ctaMain.style.display = s.ctaMain ? '' : 'none'; }
      if (ctaSub) { ctaSub.textContent = s.ctaSub || ''; if (s.ctaSubUrl) ctaSub.href = s.ctaSubUrl; ctaSub.style.display = s.ctaSub ? '' : 'none'; }
      if (badges) {
        badges.innerHTML = (s.badges || []).map(function (b) {
          return '<span class="uf-hero-badge' + (b.main ? '' : ' outline') + '">' + esc(b.t) + '</span>';
        }).join('');
      }
      var segs = prog.querySelectorAll('.uf-hp-seg');
      segs.forEach(function (seg, si) {
        seg.classList.remove('done', 'active');
        if (si < i) seg.classList.add('done');
        if (si === i) { void seg.offsetWidth; seg.classList.add('active'); }
      });
      var thumbs = rail.querySelectorAll('.uf-hero-thumb');
      thumbs.forEach(function (t, ti) { t.classList.toggle('active', ti === i); });
      var active = thumbs[i];
      if (active && rail.scrollWidth > rail.clientWidth) {
        rail.scrollTo({ left: active.offsetLeft - 16, behavior: 'smooth' });
      }
    }
    function next() { show((idx + 1) % slots.length); }
    function restart() { clearInterval(timer); timer = setInterval(next, rotate); }

    // スワイプ（SP）
    var tx = null, stage = hero.querySelector('.uf-hero-stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) { show((idx + (dx < 0 ? 1 : slots.length - 1)) % slots.length); restart(); }
        tx = null;
      }, { passive: true });
    }

    show(0); restart();
  }

  /* ===== レーン送りボタン（PC・溢れ時のみ） ===== */
  var CHEV_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m14.5 5.5-7 6.5 7 6.5"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9.5 5.5 7 6.5-7 6.5"/></svg>';
  function initLaneNav() {
    document.querySelectorAll('.uf-lane').forEach(function (lane) {
      /* 手組みレーンは .uf-lane-scroll、埋め込みレーンはスクロールを担うのが .ugc-row */
      var scroll = lane.querySelector('.uf-lane-scroll') || lane.querySelector('.uf-ugc .ugc-row');
      var head = lane.querySelector('.uf-lane-head');
      if (!scroll || !head || head.querySelector('.uf-lane-nav')) return;
      if (scroll.scrollWidth <= scroll.clientWidth + 4) return;
      var nav = document.createElement('div');
      nav.className = 'uf-lane-nav';
      nav.innerHTML = '<button class="uf-ln-btn ln-prev" aria-label="前へ">' + CHEV_L + '</button><button class="uf-ln-btn ln-next" aria-label="次へ">' + CHEV_R + '</button>';
      if (!head.querySelector('.uf-lane-more')) nav.style.marginLeft = 'auto';
      head.appendChild(nav);
      var prev = nav.querySelector('.ln-prev'), nextb = nav.querySelector('.ln-next');
      function step() { return Math.max(Math.round(scroll.clientWidth * 0.7), 320); }
      prev.addEventListener('click', function () { scroll.scrollBy({ left: -step(), behavior: 'smooth' }); });
      nextb.addEventListener('click', function () { scroll.scrollBy({ left: step(), behavior: 'smooth' }); });
      function update() {
        prev.toggleAttribute('disabled', scroll.scrollLeft <= 2);
        nextb.toggleAttribute('disabled', scroll.scrollLeft >= scroll.scrollWidth - scroll.clientWidth - 2);
      }
      scroll.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* 埋め込みカルーセル（embed.ugoitalab.com）は fetch 後に .ugc-row を作るため、
     DOMContentLoaded 時点では送りボタンを張れない。生えてきたら張り直す。
     二重付与は initLaneNav 側の head.querySelector('.uf-lane-nav') ガードで防いでいる。 */
  function watchUgcLanes() {
    var hosts = document.querySelectorAll('.uf-ugc');
    if (!hosts.length) return;
    if (!('MutationObserver' in window)) { setTimeout(initLaneNav, 2500); return; }
    var mo = new MutationObserver(function () { initLaneNav(); });
    hosts.forEach(function (h) { mo.observe(h, { childList: true, subtree: true }); });
    /* 取得が終わればそれ以上変化しないので、一定時間で監視を畳む（保険で最後に一度張る） */
    setTimeout(function () { mo.disconnect(); initLaneNav(); }, 15000);
  }

  /* ===== 講師マーキー（シームレスループのため内容を複製） ===== */
  function initMarquee() {
    document.querySelectorAll('.uf-mq-row').forEach(function (row) {
      if (row.getAttribute('data-cloned')) return;
      row.setAttribute('data-cloned', '1');
      row.innerHTML = row.innerHTML + row.innerHTML;
    });
  }

  /* ===== SPボトムシート（タブバー連動） ===== */
  function initSheets() {
    var tabbar = document.querySelector('.uf-tabbar');
    if (!tabbar) return;
    function closeAll() { document.querySelectorAll('.uf-sheet').forEach(function (s) { s.classList.remove('open'); }); }
    function setActive(tab) {
      tabbar.querySelectorAll('[data-tab]').forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-tab') === tab); });
    }
    window.ufToggleSheet = function (name) {
      var el = document.getElementById('uf-sheet-' + name);
      if (!el) return;
      var isOpen = el.classList.contains('open');
      closeAll();
      if (isOpen) { setActive('home'); } else { el.classList.add('open'); setActive(name); }
    };
    window.ufHome = function () { closeAll(); setActive('home'); window.scrollTo({ top: 0, behavior: 'smooth' }); };
    tabbar.querySelectorAll('[data-tab]').forEach(function (b) {
      var tab = b.getAttribute('data-tab');
      if (b.tagName === 'A') return; // 直接リンク（書籍等）はそのまま遷移
      b.addEventListener('click', function () {
        if (tab === 'home') window.ufHome(); else window.ufToggleSheet(tab);
      });
    });
  }


  /* ===== メガメニューを閉じる「逃げ道」（2026-09-08 ユーザー指示）=====
     開閉は CSS の `.uf-nav-item:hover` が担当している（JSに寄せると
     ホバーの追従が鈍くなるので変えない）。問題は**閉じ方が1つしかない**ことだった：
     パネルが画面の8〜9割を覆うため、マウスをパネルの外へ出す以外に閉じる手段が無い。
     そこで CSS には触らず、`.uf-mega-off` を付けて強制的に閉じる経路を3つ足す。
       ① Esc キー（キーボードの常識的な期待に合わせる）
       ② ページのスクロール（読み進めようとした＝もう用が無い、という意思表示）
       ③ ヘッダーの外へマウスが出たとき（パネルの中で上下に動かしても閉じない問題の保険）
     ★同じ項目にマウスを乗せ直したら外す。そうしないと**一度閉じたら二度と開かない**。 */
  function initMegaEscape() {
    var items = [].slice.call(document.querySelectorAll('.uf-nav-item'));
    if (!items.length) return;
    var header = document.querySelector('.uf-header');

    function closeAll() {
      items.forEach(function (it) {
        if (it.querySelector('.uf-mega')) it.classList.add('uf-mega-off');
      });
      /* 開いたままフォーカスが残ると :focus-within で開き直るので、フォーカスも外す */
      var ae = document.activeElement;
      if (ae && ae.closest && ae.closest('.uf-nav-item')) ae.blur();
    }
    function clear(it) { it.classList.remove('uf-mega-off'); }

    /* ① Esc */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeAll();
    });

    /* ② スクロール（passive・連打を間引く） */
    var t = 0;
    window.addEventListener('scroll', function () {
      if (t) return;
      t = setTimeout(function () { t = 0; closeAll(); }, 60);
    }, { passive: true });

    /* ③ ヘッダーの外へ出たとき。パネルは .uf-header の中にあるので
       ヘッダーの mouseleave がそのまま「ナビから離れた」の合図になる。 */
    if (header) header.addEventListener('mouseleave', closeAll);

    /* 乗せ直したら解除（これが無いと一度閉じたら開かなくなる） */
    items.forEach(function (it) {
      it.addEventListener('mouseenter', function () { clear(it); });
      it.addEventListener('focusin', function () { clear(it); });
    });
  }

  function esc(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
